import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginModal from "@/components/auth/LoginModal";

const UserNavMenu: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Verificar se o usuário está logado ao carregar o componente
  useEffect(() => {
    const loggedInStatus = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedInStatus);
  }, []);

  const menuItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Projetos", path: "/my-projects", requiresAuth: true },
    { label: "Moeda Social Carbono", path: "/carbon-currency" },
    { label: "Emissão", path: "/emission" },
    { label: "Rastreabilidade", path: "/traceability" },
    { label: "Certificados", path: "/certificates" },
    { label: "Compra e Venda", path: "/marketplace" },
    { label: "Compliance", path: "/compliance" },
    { label: "Aposentadoria", path: "/retirement" },
    { label: "Relatórios", path: "/relatorios" },
  ];

  const handleItemClick = (item: any, event: React.MouseEvent) => {
    if (item.requiresAuth && !isLoggedIn) {
      event.preventDefault();
      setIsLoginModalOpen(true);
    }
  };

  return (
    <>
      <div className="w-full overflow-x-auto">
        <div className="flex min-w-max border-b">
          {menuItems.map((item) => (
            <Link
              key={item.label}
              to={item.path}
              className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${
                currentPath === item.path
                  ? "border-b-2 border-[#0e7cb4] text-[#0e7cb4]"
                  : "text-gray-700 hover:text-[#0e7cb4] hover:border-b-2 hover:border-[#0e7cb4] transition-colors"
              }`}
              onClick={(e) => handleItemClick(item, e)}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Modal de Login */}
      <LoginModal 
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onSuccess={() => setIsLoggedIn(true)}
      />
    </>
  );
};

export default UserNavMenu;
